// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"26b90ca3","201":"6745db7f","488":"33bfaf5c","701":"aabda8d5","858":"2b659894"}[chunkId] + ".chunk.js";
};